import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function MonthSelector({months, month, setMonth, year}) {


    useEffect(() => {
        //console.log(month?.number, "month number MonthSelector.js")

        //console.log(months, "MONTHS ARRAY")

        //console.log(months.indexOf(month))


    }, [month])

    return (
        <div className="col-12 my-3">
                
            <div className="row no-gutters px-1">
                {months?.map((currentMonth, index) => {
                    //console.log(index,  month)
                    return (
                        <div className="col-2 col-md-2 col-lg-1 mb-2" key={index}>
                            <Link to={`/?item=1&month=${index+1}&year=${year}`} className={month?.number === index+1 ? "bg-primary text-white button" : "bg-light button"} onClick={() => setMonth(currentMonth)}>{currentMonth.month}</Link>
                        </div>
                    )
                })}
            </div>
        </div>
    )

}
export default MonthSelector

